export const generateArticleId = () => {
  const timestamp = Date.now().toString()
  const randomDigit = Math.floor(Math.random() * 10).toString()

  return `${timestamp}${randomDigit}`.slice(0, 12).padStart(12, '0')
}
